// Resume data for Mara Martins - Updated from LinkedIn profile

export const resumeData = {
  summary: `Bridging AI with language, culture, and technology to help global companies expand with confidence and impact. With 15+ years in localization, I bring a blend of program management, marketing expertise, and AI innovation — always with a focus on empowering teams and mentoring the next generation of leaders.`,
  
  experience: [
    {
      id: 0,
      company: 'Career Transition',
      logo: null,
      role: 'Open to New Opportunities',
      location: 'San Francisco Bay Area',
      period: 'Jul 2025 - Present',
      type: 'Career Break',
      description: 'Following the announcement of MIIS closure by June 2027, I am actively seeking new opportunities in AI Localization Strategy, Program Management, and Education.',
      achievements: [
        'Leveraging 15+ years of experience in localization and program management',
        'Open to roles in AI/Localization leadership, GTM strategy, and education',
        'Available for full-time positions, consulting, or advisory roles'
      ],
      linkedInPost: 'https://www.linkedin.com/posts/maramartinspt_middlebury-to-close-miis-by-june-2027-the-share-7367252461322977280-JJ6m'
    },
    {
      id: 1,
      company: 'Middlebury Institute of International Studies',
      logo: null,
      role: 'Visiting Professor',
      location: 'Monterey, California',
      period: 'Jul 2023 - Jul 2025',
      type: 'Full-time',
      description: 'Teaching graduate-level courses on Translation and Localization Management Program and advocating for Responsible AI adoption in Localization.',
      achievements: [
        'Designed and launched the institute\'s first AI Event Series "AI in Localization" by collaborating with industry leaders (GitLab, Block, Coupa, Smartling)',
        'Designed and taught graduate-level courses on Global Program Management, AI adoption in Localization, and Automation',
        'Mentored 90+ students across three cohorts, guiding teams to build E2E market ready localization and GLM workflows'
      ]
    },
    {
      id: 2,
      company: 'Block',
      logo: null,
      role: 'Program Management Lead - Localization',
      location: 'United States',
      period: 'Nov 2021 - Nov 2022',
      type: 'Full-time',
      description: 'Led a team of Program Managers responsible for supporting the global expansion of Square\'s ecosystem of products.',
      achievements: [
        'Led a team of Program Managers (5 reports and expanded to 15 reports)',
        'Supported vendors delivering multilingual marketing campaigns and product launches across 10+ markets',
        'Partnered cross-functionally with Brand, Product Marketing, Legal, and Regional teams',
        'Introduced scalable workflows and quality frameworks to accelerate go-to-market readiness'
      ]
    },
    {
      id: 3,
      company: 'LinkedIn',
      logo: null,
      role: 'Senior Marketing Manager - Localization',
      location: 'Sunnyvale, California',
      period: 'Mar 2020 - Oct 2021',
      type: 'Full-time',
      description: 'Managing direct reports and overseeing day-to-day team processes and operational excellence.',
      achievements: [
        'Managed direct reports annual compensation and career discussions',
        'Coached and mentored teams to work on high-impact initiatives',
        'Drove global cross-teams coordination managing a diverse team across multiple timezones',
        'Supported the growth of LinkedIn International strategy during COVID, including "Stories" and LinkedIn Learning internationalization across 17 markets'
      ]
    },
    {
      id: 4,
      company: 'Microsoft',
      logo: null,
      role: 'Sr. Global Marcom Manager - Localization & Operations',
      location: 'Greater Seattle Area',
      period: 'Jun 2016 - Mar 2020',
      type: 'Full-time',
      description: 'Driving the overall localization program execution, strategy and innovation of MSCOM and Store.',
      achievements: [
        'Managed multi-vendor team talent (team of over 15 people) and global product offering for 200 markets (100 languages)',
        'Responsible for efficient budget management and key priorities allocation',
        'Ensured customer flawless experiences and business impact across the globe'
      ]
    },
    {
      id: 5,
      company: 'Infoblox (via Acclaro)',
      logo: null,
      role: 'Marketing Localization Project Manager',
      location: 'Santa Clara, California',
      period: 'Mar 2015 - Jun 2016',
      type: 'Contract',
      description: 'Localization Project Manager responsible for ensuring operational excellence for cross-functional globalization programs.',
      achievements: [
        'Ensured operational excellence for cross-functional globalization programs for EMEA, LATAM and APAC',
        'Innovation enthusiast and advocate for Go Global, Act Local strategies'
      ]
    },
    {
      id: 6,
      company: 'Apple',
      logo: null,
      role: 'Project Manager - Localization',
      location: 'Cupertino, California',
      period: 'Oct 2014 - Mar 2015',
      type: 'Contract',
      description: 'A truly dynamic team player taking a leadership role as a Localization Project Manager for Apple.',
      achievements: [
        'Responsible for project scope identification, file organizing/processing in Apple CAT tools',
        'Vendor allocation, vendor Q&A, and various project-related administrative tasks'
      ]
    },
    {
      id: 7,
      company: 'Career Break / Relocation',
      logo: null,
      role: 'UK to USA Transition',
      location: 'International',
      period: 'Jan 2012 - Oct 2014',
      type: 'Career Break',
      description: 'Career break for international relocation from United Kingdom to United States.',
      achievements: [
        'Relocated from London, UK to San Francisco Bay Area, USA',
        'Obtained work authorization and established professional network in the US market'
      ]
    },
    {
      id: 8,
      company: 'Hogarth Worldwide',
      logo: null,
      role: 'Senior Transcreation Account Manager',
      location: 'London, United Kingdom',
      period: 'Jan 2011 - Jan 2012',
      type: 'Full-time',
      description: 'Managing an in-house team of up to 10 people for several markets (FR, BE, ES, PT & NL).',
      achievements: [
        'Oversaw production of culturally adapted marketing communications for major global brands',
        'Pro-active interaction with Procurement and AM Teams to build up client portfolio',
        'Focused on pitches to win new clients and businesses such as for EU institutions'
      ]
    },
    {
      id: 9,
      company: 'Hogarth Worldwide',
      logo: null,
      role: 'Transcreation Account Manager',
      location: 'London, United Kingdom',
      period: 'Jan 2010 - Jan 2011',
      type: 'Full-time',
      description: 'Responsible for the quality of culturally adapted marketing communications in multiple industries.',
      achievements: [
        'Pre-screening a team of translators managing the transcreation process',
        'Ensuring correct tone and message of brands in local markets',
        'Planning and executing complex schedules to accommodate client needs',
        'Acting as brand ambassador for Medical major brands in Portuguese market'
      ]
    },
    {
      id: 10,
      company: 'Sony UK',
      logo: null,
      role: 'B2B & B2C Prime-vox Display Coordinator',
      location: 'Basingstoke, United Kingdom',
      period: 'Aug 2007 - Jan 2010',
      type: 'Full-time',
      description: 'Responsible for Customer Service Support for Iberia Market.',
      achievements: [
        'Active facilitator providing business customer satisfaction',
        'Translator and Interpreter (English, Spanish and Portuguese)'
      ]
    },
    {
      id: 11,
      company: 'Sony Portugal',
      logo: null,
      role: 'Translator and International Project Manager',
      location: 'Lisbon, Portugal',
      period: 'Jan 2007 - Jul 2007',
      type: 'Full-time',
      description: 'Self-assured management and workflow of projects and events as an Interpreter/Translator.',
      achievements: [
        'Translating and modifying course materials and products to suit a Portuguese language environment',
        'Interpreter for Digital Asset Management Production and Transmission within RTP',
        'Product localization for Sony Snap Lab'
      ]
    },
    {
      id: 12,
      company: 'RTP (Rádio e Televisão de Portugal)',
      logo: null,
      role: 'Translation/Subtitling and Audio-description Internship',
      location: 'Lisbon, Portugal',
      period: 'Jan 2006 - Oct 2006',
      type: 'Internship',
      description: 'Text adaptation, subtitling of television programs for accessibility.',
      achievements: [
        'Subtitling of television programs such as novels, competitions, news',
        'Focused on accessibility for people with hard of hearing difficulties'
      ]
    },
    {
      id: 13,
      company: 'European Union - DG Translation',
      logo: null,
      role: 'EU Terminology Traineeship',
      location: 'Brussels, Belgium',
      period: 'Sep 2006',
      type: 'Internship',
      description: 'IATE database management at the Directorate-General for Translation.',
      achievements: [
        'Introduction of terms, content management and update',
        'Translation and Localization process'
      ]
    }
  ],
  
  education: [
    {
      degree: 'University Degree in Translation & Interpretation Studies',
      institution: 'Escola Superior de Tecnologia e Gestão (Polytechnic Institute of Leiria)',
      location: 'Leiria, Portugal',
      year: '2001 - 2007',
      details: 'Focus on Translation and Interpretation'
    }
  ],
  
  onlineLearning: [
    {
      course: 'AI Python Introduction',
      provider: 'Coursera',
      year: '2025 (ongoing)'
    },
    {
      course: 'High Impact Presentations',
      provider: 'Dale Carnegie',
      year: '2015'
    }
  ],
  
  skills: {
    gtm: [
      'Regional Go-to-Market (GTM) Strategy & Execution',
      'Global Product & Feature Launch Management',
      'Market Readiness & Launch Enablement',
      'Marketing Operations & Launch Execution'
    ],
    program: [
      'Cross-Functional Program Leadership',
      'End-to-End Program & Project Management',
      'Operational Excellence & Workflow Optimization',
      'Stakeholder Management in Matrixed Organizations'
    ],
    localization: [
      'Global Localization Strategy (45+ Markets)',
      'Change Management & Adoption Enablement',
      'Localization at Scale',
      'Vendor Management'
    ],
    technology: [
      'Smartling',
      'Figma',
      'CMS & TMS Integration',
      'Agile Workflows',
      'Python (Learning)',
      'GitHub'
    ]
  },
  
  languages: [
    { language: 'Portuguese', level: 'Native', flag: '🇵🇹' },
    { language: 'English', level: 'Fluent', flag: '🇺🇸' },
    { language: 'Spanish', level: 'Professional', flag: '🇪🇸' }
  ],
  
  certifications: [],
  
  awards: [],
  
  links: {
    linkedin: 'https://www.linkedin.com/in/maramartinspt',
    github: 'https://github.com/marapt',
    email: 'marapt@gmail.com',
    phone: '+16506669468'
  }
};
